import React from 'react';
import ReactDOM from 'react-dom';
import { Amplify } from 'aws-amplify';
import { Hub } from 'aws-amplify/utils';
import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';
import mixpanel from 'mixpanel-browser';
import { Provider } from 'react-redux';
// import { AmplifyProvider } from '@aws-amplify/ui-react';
import { StyledEngineProvider } from '@mui/material/styles';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { smorgStore } from './app/smorg_store';
import { initTrackingAfterSignIn } from './operations/tracking_operations';
import { isEmbeddedInSmorgCompanion } from './services/smorg_companion_auth';
import { applyStartingBackgroundColorInUrl } from './services/spaces';
import amplifyconfig from './amplifyconfiguration.json';
import ServerStatusControl from './components/common/server_status_control';
import ThemeChangeListener from './components/common/theme_change_listener';

// eslint-disable-next-line import/no-extraneous-dependencies, @typescript-eslint/no-var-requires
const hasOwn = require('object.hasown');

applyStartingBackgroundColorInUrl();

if (!Object.hasOwn) {
  console.log('Adding shim for Object.hasOwn');
  hasOwn.shim();
}

mixpanel.init('d56f192f1fe1b37bd507dd15bdabe3ad', {
  debug: true,
  ignore_dnt: true,
  api_host: 'https://api-eu.mixpanel.com',
});
mixpanel.register({
  is_embedded_in_smorg_companion: !!isEmbeddedInSmorgCompanion(),
});

Sentry.init({
  dsn: 'https://2011978e2e6f4a16ac5d13ae7e2c1e50@o339105.ingest.sentry.io/6075424',
  integrations: [new Integrations.BrowserTracing()],
  normalizeDepth: 4,
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.2,
});

Amplify.configure(amplifyconfig);

Hub.listen('auth', (data) => {
  console.log({ data });
  switch (data.payload.event) {
    case 'signedIn': {
      const { username: userId, signInDetails } = data.payload.data;
      const { loginId: email } = signInDetails;
      console.log('User signed in:', { userId, email });
      initTrackingAfterSignIn(userId, email);
      break;
    }
    default:
  }
});

/*
 * This React app still uses the deprecated `ReactDOM.render` method,
 * meaning it behaves like React 17.
 * In React 18, you should use `createRoot` from 'react-dom/client'.
 * We cannot upgrade because the react-trello library throws runtime errors
 * such as:
NotFoundError: Failed to execute 'removeChild' on 'Node'
The node to be removed is not a child of this node.
The above error occurred in the <Draggable> component
 */
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <React.StrictMode>
    <Provider store={smorgStore}>
      {/* <AmplifyProvider> */}
      <StyledEngineProvider injectFirst>
        <App />
        <ThemeChangeListener />
        <ServerStatusControl />
      </StyledEngineProvider>
      {/* </AmplifyProvider> */}
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// https://dev.to/maciejtrzcinski/100vh-problem-with-ios-safari-3ge9
const appHeight = () => {
  const doc = document.documentElement;
  doc.style.setProperty('--app-height', `${window.innerHeight}px`);
};
window.addEventListener('resize', appHeight);
appHeight();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
